import PropTypes from 'prop-types';

import { stepsFactory } from 'components/Booking-new/utils/steps';

import TimeContainer from './TimeContainer';
import VariantA from './Variants/VariantA';

const timeVariants = {
  a: VariantA,
};
const timeStepWrapper = TimeContainer;
const Time = ({ variant, data, navigation, userData }) => {
  return stepsFactory(timeVariants, variant, { data, navigation, userData }, timeStepWrapper);
};

Time.propTypes = {
  variant: PropTypes.oneOf(['a']),
};

export default Time;
